const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000/api";

async function request(path, options = {}) {
  const res = await fetch(`${BASE_URL}${path}`, {
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    ...options,
  });

  if (!res.ok) {
    let message = `Request failed: ${res.status}`;
    try {
      const body = await res.json();
      if (body?.error) message = body.error;
    } catch {
      // response had no JSON body; keep the default message
    }
    throw new Error(message);
  }

  if (res.status === 204) return undefined;
  return res.json();
}

export const fetchBoards = () => request("/boards");

export const createBoard = (title, columnNames) =>
  request("/boards", { method: "POST", body: JSON.stringify({ title, columnNames }) });

export const updateBoard = (boardId, title, columnNames) =>
  request(`/boards/${boardId}`, { method: "PATCH", body: JSON.stringify({ title, columnNames }) });

export const deleteBoard = (boardId) => request(`/boards/${boardId}`, { method: "DELETE" });

export const createColumn = (boardId, name) =>
  request(`/boards/${boardId}/columns`, { method: "POST", body: JSON.stringify({ name }) });

export const deleteColumn = (columnId) => request(`/columns/${columnId}`, { method: "DELETE" });

export const reorderColumns = (boardId, orderedColumnIds) =>
  request(`/boards/${boardId}/columns/reorder`, {
    method: "PATCH",
    body: JSON.stringify({ orderedColumnIds }),
  });

export const createTask = (columnId, { title, description, subTasks }) =>
  request(`/columns/${columnId}/tasks`, {
    method: "POST",
    body: JSON.stringify({ title, description, subtasks: subTasks }),
  });

export const updateTask = (taskId, { title, description, subTasks }) =>
  request(`/tasks/${taskId}`, {
    method: "PATCH",
    body: JSON.stringify({ title, description, subtasks: subTasks }),
  });

export const deleteTask = (taskId) => request(`/tasks/${taskId}`, { method: "DELETE" });

export const moveTask = (taskId, columnId, position) =>
  request(`/tasks/${taskId}/move`, {
    method: "PATCH",
    body: JSON.stringify({ columnId, position }),
  });

export const toggleSubtask = (subtaskId) =>
  request(`/subtasks/${subtaskId}/toggle`, { method: "PATCH" });
